<template>
  <div class="fullDiv">
<!--    <div class="inner">-->
      <ul class="flexRow">
        <li
          class="navLi"
          :class="{ navLiSelect: changedNav == index }"
          @click="handleClickNav(index)"
          v-for="(item, index) of List"
          :key="index"
        >
          {{ item.title }}
        </li>
      </ul>
<!--    </div>-->
  </div>
</template>

<script>
import { jump } from "../../untils/auth";
export default {
  data() {
    return {
      changedNav: 0,
      List: [],
    };
  },
  watch: {
    $route(val) {
      var index = this.List.findIndex(item => item.path == val.path);
      console.log('index:----------------',val.query.index);
      if(index == '-1'){
        index = val.query.index;
      }
      // if (val.path == "/education/index") {
        this.changedNav = index;
      // }
    },
  },
  created() {
    const index = this.List.findIndex(item => item.path == this.$route.path);
    this.changedNav = index;
  },
  methods: {
    jump,
    handleClickNav(idx) {
      this.changedNav = idx;
      this.jump(this.List[idx].path);
    },
  },
};
</script>

<style>
.fullDiv .flexRow {
  justify-content: left;
  height: 60px;
  /*background: url("../../assets/images/changtiao.jpg");*/
}
.flexRow li.navLi.navLiSelect {
  border-top: 0.01rem solid #CCCCCC;
  border-bottom: 0.01rem solid #CCCCCC;
  background: #f8f8f8;
  color: #228457;
}

</style>



// WEBPACK FOOTER //
// src/components/ivew/fullDiv.vue